import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { useCompanyProposal } from '../../hooks/useCompanyProposal';
import ProporsalForm from './proposalForm';
import { useList } from '../../hooks/useList';
import { Modal } from '../../components';

type modalProps = {
  isOpen: boolean;
  title: string;
  description: string;
  buttonText: string;
  redirectUrl?: string | undefined;
};

const CompanyProposal = () => {
  const { recaptchaSiteKey } = useFlags();
  const [firstName, setFirstName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [recaptchaValue, setRecaptchaValue] = useState<string>('');
  const [modal, setModal] = useState<modalProps>({
    isOpen: false,
    title: '',
    description: '',
    buttonText: '',
  });
  const { list } = useList();
  const { onSubmit, isLoading, success, error, setError, setSuccess } = useCompanyProposal({
    list,
    xRecaptcha: recaptchaValue,
  });
  const { t } = useTranslation('company_proposal');

  useEffect(() => {
    if (error) {
      setModal({
        isOpen: true,
        title: t('modalErrorTitle'),
        description: t('modalErrorDescription'),
        buttonText: t('modalErrorButtonText'),
      });
    }
    if (success) {
      setModal({
        isOpen: true,
        title: t('modalSuccessTitle'),
        description: t('modalSuccessDescription'),
        buttonText: t('modalSuccessButtonText'),
      });
    }
  }, [success, error]);

  const handleToggle = () => window.location.replace(`${window.location.origin}/clube-smiles`);

  const handleOnClick = () => {
    if (success) {
      window.location.replace(`${window.location.origin}/clube-smiles`);
    } else {
      setError(false);
      setSuccess(false);
      setModal({
        isOpen: false,
        title: '',
        description: '',
        buttonText: '',
      });
    }
  };

  return (
    <>
      <div data-testid="vbz-company-proposal" id="vbz-company-proposal">
        <div className="vbz-cp-container">
          <div className="vbz-cp-card">
            <div className="vbz-cp-card-left">
              <div className="vbz-card-left-title">{t<string>('cardtitle')}</div>
              <div className="vbz-card-left-subtitle">{t<string>('cardSubtitle')}</div>
              <ProporsalForm
                recaptchaKey={recaptchaSiteKey}
                setEmail={setEmail}
                setFirstName={setFirstName}
                setPhoneNumber={setPhoneNumber}
                setRecaptchaValue={setRecaptchaValue}
                email={email}
                firstName={firstName}
                phoneNumber={phoneNumber}
                recaptchaValue={recaptchaValue}
                onSubmit={onSubmit}
                isLoading={isLoading}
              />
            </div>
            <div className="vbz-cp-card-right" />
          </div>
        </div>
      </div>
      <Modal
        buttonText={modal?.buttonText}
        description={modal?.description}
        isOpen={modal?.isOpen}
        title={modal?.title}
        handleOnClick={handleOnClick}
        toggle={handleToggle}
      />
    </>
  );
};

export default CompanyProposal;
